// extracted by mini-css-extract-plugin
export default {"counterWrap":"MenuListPart_counterWrap__m66BG","counter":"MenuListPart_counter__LiGDO","text":"MenuListPart_text__AaNVK"};